import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import { DatePicker } from '@mui/x-date-pickers';
import { renderDatePickerLocaleText } from 'utils';
import { GridFilterInputValueProps } from '@mui/x-data-grid-premium';

const GridFilterDateInput = (props: GridFilterInputValueProps) => {
  const intl = useIntl();
  const { item, applyValue } = props;

  const handleFilterChange = (newValue: unknown) => {
    applyValue({ ...item, value: newValue });
  };

  return (
    <DatePicker
      value={item.value ? dayjs(item.value) : null}
      localeText={renderDatePickerLocaleText(intl)}
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          variant: 'standard',
        },
        inputAdornment: {
          sx: {
            '& .MuiButtonBase-root': {
              marginRight: -1,
            },
          },
        },
      }}
      onChange={handleFilterChange}
    />
  );
};

export default GridFilterDateInput;
